<template>
  <el-dialog
    :before-close="noDialog"
    :fullscreen="dialogFullscreen"
    :visible.sync="dialog"
    title="设备转移"
    @close="handleDialogClose"
  >
    <el-form
      ref="params"
      :model="params"
      :rules="paramsRules"
      label-width="auto"
    >
      <el-form-item label="设备编号">
        <el-input v-model="params.deviceId" disabled />
      </el-form-item>
      <el-form-item label="选择小区" prop="groupId">
        <el-select
          v-model="params.groupId"
          filterable
          ref="select"
          @focus="closeReadOnly"
          @hook:mounted="closeReadOnly"
          @visible-change="closeReadOnly"
          placeholder="请选择小区"
        >
          <el-option
            v-for="item in _groupList"
            :key="item.id"
            :label="item.groupName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="noDialog">取 消</el-button>
      <el-button type="primary" @click="changePost">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import dialogMixin from "@/mixin/dialogMixin";
import resDisposeMixin from "@/mixin/resDisposeMixin";
import getGroupList from "@/api/device/device-group-manage/getGroupList";
import agentTransferDevice from "@/api/device/charging-pile-manage/agentTransferDevice";

export default {
  name: "transferDialog",
  mixins: [dialogMixin, resDisposeMixin],
  props: {
    deviceId: Number,
    transferInitId: Number,
  },
  watch: {
    deviceId(newValue) {
      this.params.deviceId = newValue;
    },
    transferInitId(newValue) {
      this.params.transferInitId = newValue;
    },
  },
  data() {
    return {
      paramsRules: {
        groupId: [{ required: true, message: "请选择小区" }],
      },
      params: {
        deviceId: undefined,
        transferInitId: undefined,
        groupId: undefined,
      },
      groupList: [],
    };
  },
  created() {
    getGroupList().then((res) => {
      this.groupList = res.data;
    });
  },
  computed: {
    _groupList() {
      return this.groupList.filter((g) => g.id != this.params.transferInitId);
    },
  },
  methods: {
    closeReadOnly(value) {
      this.$nextTick(() => {
        if (!value) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner"); 
          input.removeAttribute("readonly"); 
          // this.$refs.select.blur();  根据tip自行判断是否添加
        }
      });
    },
    changePost() {
      this.$refs["params"].validate((valid) => {
        if (valid) {
          agentTransferDevice({
            deviceId: this.params.deviceId,
            groupId: this.params.groupId,
          }).then((res) => {
            this.resEditNoDialog({ res });
          });
        }
      });
    },
    handleDialogClose() {
      this.$refs["params"].resetFields();
    },
  },
};
</script>
